export const CREATE_ACCOUNT_STEPS = {
  createAccount: 0,
  verifyCode: 1,
  finishRegister: 2,
}

export const NEW_WITHDRAWAL_STEPS = {
  requestWithdrawal: 0,
  confirmWithdrawal: 1,
}

export const MENU_SETTINGS = {
  integrations: 0,
  notifications: 1,
  terms: 2,
  privacy: 3,
  plans: 4,
  pricing: 5,
}